// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  compId: __t.u64().primaryKey().name("comp_id"),
  shipId: __t.u64().name("ship_id"),
  slot: __t.string(),
  itemKey: __t.string().name("item_key"),
  name: __t.string(),
  quality: __t.u32(),
  propsJson: __t.string().name("props_json"),
  serial: __t.string(),
  equippedAt: __t.timestamp().name("equipped_at"),
});
